import { Spin } from 'antd';
import React, { useState } from 'react'
import AuthStoreSelect from '../../components/AuthStoreSelect';
import ContentLayout from '../ContentLayout'

function ReturnPage() {
    const [storeId, setStoreId] = useState();
    const [loading, ] = useState(false);

    return (
        <ContentLayout title="還車">
            <Spin spinning={loading}>
                <AuthStoreSelect value={storeId} onSelect={(value) => setStoreId(value)} />
            </Spin>
        </ContentLayout>
    )
}

export default ReturnPage